import React from "react";
import { Button, DatePicker, Input, Select } from "antd";
import type { TravelMode } from "../Homepage";

const ICONS = "/iceholidays-assets/images/icons";

interface Props {
  mode: TravelMode;
  onModeChange: (mode: TravelMode) => void;
}

// Hero banner + search bar for the redesigned landing page (v2). Tour/Cruise
// toggle switches the search context (owned by Homepage). Design-phase: submits
// are stubbed and options are placeholders until wired to the list/search services.
export default function HeroSearch({ mode, onModeChange }: Props) {
  return (
    <section id="hero-v2">
      <div className="hero-v2__overlay">
        <div className="hero-v2__copy">
          <h1>Travel Further. Experience More.</h1>
          <p>Exclusive tours, cruises and holidays with Malaysia's trusted travel specialist.</p>
        </div>

        <div className="hero-v2__toggle">
          <button
            className={mode === "tour" ? "is-active" : ""}
            onClick={() => onModeChange("tour")}
            type="button"
          >
            <img src={`${ICONS}/icon-toggle-tour.png`} alt="" aria-hidden="true" /> Tour
          </button>
          <button
            className={mode === "cruise" ? "is-active" : ""}
            onClick={() => onModeChange("cruise")}
            type="button"
          >
            <img src={`${ICONS}/icon-toggle-cruise.png`} alt="" aria-hidden="true" /> Cruise
          </button>
        </div>

        <div className="hero-v2__search">
          <div className="hero-v2__field">
            <img src={`${ICONS}/icon-search-location.png`} alt="" aria-hidden="true" />
            <Input variant="borderless" placeholder="Where would you like to go?" />
          </div>
          <div className="hero-v2__field hero-v2__field--depart">
            <img src={`${ICONS}/icon-search-city.png`} alt="" aria-hidden="true" />
            <Select variant="borderless" placeholder="Departure City" options={[]} popupMatchSelectWidth={false} suffixIcon={null} />
          </div>
          <div className="hero-v2__field">
            <img src={`${ICONS}/icon-search-date.png`} alt="" aria-hidden="true" />
            <DatePicker variant="borderless" placeholder="Travel Date" picker="month" suffixIcon={null} />
          </div>
          <div className="hero-v2__field">
            <img src={`${ICONS}/icon-search-brand.png`} alt="" aria-hidden="true" />
            <Select variant="borderless" placeholder="Brand" options={[]} popupMatchSelectWidth={false} suffixIcon={null} />
          </div>
          <Button type="primary" className="hero-v2__search-btn">Search Holidays</Button>
        </div>
      </div>
    </section>
  );
}
